// eslint-disable-next-line
export default {
    name: "Community",
    status: {
        router: true,
        redux: true
    }
}
